<template>
  <div class="email">
    <div class="row">
      <div class=" col-lg-12">
        <aside class="widget card widget--sidebar widget-standings">
          <header class="card__header card__header--shop-filter">
            <div class="shop-filter">
              <h4 class="shop-filter__result" style="text-align: left; font-size: 16px;">
                Quản lý tài khoản TQC Tần Tử Anh
              </h4>
            </div>
          </header>
          <div class="widget__content card__content">
            <br />
            <div class="row">
              <div class="col-md-3">
                <Menu/>
              </div>
              <div class="col-md-5">
                <div class="form-group">
                  <div>
                    <div class="text-left"><label for="account">Tài khoản</label> &nbsp;&nbsp;&nbsp; <b class="text-green">{{ user.account }}</b></div>
                  </div>
                  <div>
                    <div class="text-left"><label for="email">Email cũ</label></div>
                    <div><input type="email" maxlength="55" v-model="email" placeholder="Nhập địa chỉ Email cũ"
                        class="form-control" id="email"></div>
                  </div>
                  <div>
                    <div class="text-left"><label for="new_email">Email mới</label></div>
                    <div><input type="email" maxlength="55" v-model="new_email" placeholder="Nhập địa chỉ Email mới"
                        class="form-control" id="new_email"></div>
                  </div>
                  <div>
                    <div class="text-left"><label for="phone">Số điện thoại</label></div>
                    <div><input type="number" maxlength="15" v-model="phone" placeholder="Nhập Số điện thoại"
                        class="form-control" id="phone"></div>
                  </div>
                  <div>
                    <br />
                    <div>
                      <button class="btn btn-warning btn-sm" v-on:click="changeEmail()">Đổi Email</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import Vue from 'vue'
  import Menu from './Menu'

  export default {
    name: 'ChangeEmail',
    components: {
      Menu
    },
    props: {
      tqc_api: '',
      user: {},
      token: ''
    },
    mounted() {
      this.$emit('get-info')
    },
    methods: {
      changeEmail() {
        if (this.clicked) {
          return false
        }
        if (!this.validate()) {
          // alert('Có gì đó sai sai !')
          return false
        }
        this.clicked = true

        axios.put(`${this.tqc_api}update-email`, {
          token: this.token,
          email: this.email,
          new_email: this.new_email,
          phone: this.phone,
        }).then(({data}) => {
          this.clicked = false          
          localStorage.token = ''
          localStorage.user = ''
          localStorage.daily = ''
          alert('Đổi Email thành công, vui lòng đăng nhập lại !')
          this.$router.push({
            name: 'Login'
          })
        }).catch(error => {
          this.clicked = false
          alert('Thông tin không chính xác !')
        })
      },
      validate() {
        var isValid = 0
        if (this.email.length < 6) {
          alert('Email không được để trống !')
          return false
        }
        if (this.new_email.length < 6) {
          alert('Email mới không được để trống !')
          return false
        }
        if (this.new_email == this.email) {
          alert('Email mới không giống Email cũ !')
          return false
        }
        if (this.phone.length < 6) {
          alert('Số điện thoại không được để trống !')
          return false
        }

        return true
      },      
    },
    data() {
      return {
        clicked: false,
        phone: '',
        new_email: '',
        email: '',        
      }
    }
  }
</script>

<style scoped>
  h3 {
    margin: 40px 0 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .acc_info {
    width: 450px;
    height: 202px;
    background-repeat: no-repeat;
    background-position: left bottom;
    font-size: 15px;
    color: white;
  }
  .text-red {
    color: red;
  }
  .text-green {
    color: #2be428;
  }
  input {
    height: 35px;
    margin-bottom: 8px;
  }
</style>